import { gql } from '@apollo/client';

export const GET_CONTRACT_VERSION_LINES_BY_CRITERIA = gql`
  query getContractVersionLinesByCriteria(
    $criteria: ContractLineFilterCriteriaType!
    $limit: Float
    $offset: Float
    $order: OrderBy
  ) {
    getContractVersionLinesByCriteria(
      criteria: $criteria
      limit: $limit
      offset: $offset
      order: $order
    ) {
      count
      rows {
        id
        contractLineVersion {
          id
          contractLineId
          versionNumber
        }
        scheduleLine
        standardItemId
        standardItem {
          id
          standardItemNumber
          title
          program
          vehicleType
          vehicleGroup {
            title
            code
          }
          vehicleTypeCode {
            title
          }
        }
        make {
          makeCode
          makeName
        }
        model {
          modelCode
          modelName
        }
        chassisMake {
          makeCode
          makeName
        }
        chassisModel {
          modelCode
          modelName
        }
        isDirect
        makeCode
        modelCode
        chassisMakeCode
        chassisModelCode
        modelYear
        orderStartDate
        orderEndDate
        solicitationLineId
        manufacturerModelNumber
        additionalInformation
      }
      hasMore
    }
  }
`;

export const GET_CONTRACT_VERSION_LINES_FOR_FILTERS = gql`
  query getContractVersionLinesForFilters(
    $contractHeaderId: String!
    $versionNumber: Float!
  ) {
    getContractVersionLinesForFilters(
      contractHeaderId: $contractHeaderId
      versionNumber: $versionNumber
    ) {
      id
      scheduleLine
      make {
        makeCode
        makeName
      }
      model {
        modelCode
        modelName
      }
      chassisMake {
        makeCode
        makeName
      }
      chassisModel {
        modelCode
        modelName
      }
      makeCode
      modelCode
      chassisMakeCode
      chassisModelCode
      modelYear
      manufacturerModelNumber
    }
  }
`;
